import type {ReactElement} from 'react';
import type {Type} from '@Components/button';
import type {FlatIconColor} from '@Components/icon-v2/icon.types';
import type {PanelFooterSecondaryActionType} from '@Components/panel/components/panel-footer-secondary-actions';

export const CONFIRMATION_DIALOG_MODAL_WIDTH = '560px';
export const CONFIRMATION_DIALOG_MODAL_BORDER_RADIUS = 12;

export enum ConfirmationDialogIconStyle {
  FLAT = 'flat',
  BREATHING = 'breathing',
}

export interface ConfirmationDialogAction {
  text: string;
  textCompact?: string;
  onClick: VoidFunction;
  type?: Type;
  icon?: string;
  isLoading?: boolean;
  disabled?: boolean;
}

export interface ConfirmationDialogLayoutProps {
  title: string;
  description?: string;
  customContent?: ReactElement;
  icon?: string;
  iconColor?: FlatIconColor;
  iconStyle?: ConfirmationDialogIconStyle;
  showIcon?: boolean;
  primaryAction: ConfirmationDialogAction;
  secondaryAction?: ConfirmationDialogAction;
  footerSecondaryContent?: PanelFooterSecondaryActionType;
  onClose: VoidFunction;
  showCloseButton?: boolean;
  showBackButton?: boolean;
}
